@if (showFilter) {
  <app-side-filter
    (filterRemoved)="removeFilter($event)"
    [appliedFilters]="appliedFilters"
    [columnFilters]="columnFilters"
    [isTimeSearchAvailable]="isTimeSearchAvailable"
    [isNotDialLogs]="isNotDialLogs"
    [minDate]="minDate"
    [showCalendarFilter]="showCalendarFilter"
    [isUTC]="isUTC"
    [hideTextSearch]="hideTextSearch"
    [showAddFilter]="showAddFilter"
    class="header-filter"
  ></app-side-filter>
}
<div class="hidden-items-container">
  @if (gridRendered) {
    <div
      class="hidden-columns-list"
      [ngClass]="{ 'hidden-results': hiddenResults }"
      id="ColumnVisibilityHeader"
      >
      @for (col of hiddenColumns; track col) {
        <div
          (click)="setColumnVisibilityColumn(col, true)"
          class="hidden-column-item ag-dnd-ghost ag-unselectable ag-theme-alpine"
          id="ColumnVisibility_{{ col.headerName }}"
          title="Show column"
          >
          <span class="ag-dnd-ghost-icon">
            <span class="ag-icon ag-icon-eye-slash"></span>
          </span>
          <div class="ag-dnd-ghost-label">{{ col.headerName }}</div>
        </div>
      }
      @if (showToggle) {
        <div class="system-policies-toggle">
          <span class="toggle-text">Show System Generated Policies</span>
          <div class="toggle" [ngClass]="{ on: showSystem }" (click)="showSystemToggled()">
            <span [hidden]="!showSystem" style="margin-left: -1.125rem">SHOW</span>
            <span [hidden]="showSystem" style="margin-right: -0.9375rem">HIDE</span>
            <div class="switch"></div>
          </div>
        </div>
      }
    </div>
  }
  @if (hiddenResults) {
    <div class="hidden-results-container" [ngClass]="{ 'loading-results': loadingHiddenResults }">
      <span class="toggle-text"
        >Some results have been filtered. <a (click)="enablePowerUser()">Click here</a> to enable power user mode
        and display hidden results.
      </span>
      @if (loadingHiddenResults) {
        <span class="spinner"></span>
      }
    </div>
  }
</div>
<div waResizeBox="content-box" (waResizeObserver)="resizeGridColumnsDebounced($event)" class="nf-ag-grid" id="ItemTable">
  <ag-grid-angular
    #nfAgGrid
    (gridReady)="onGridReady($event)"
    [columnDefs]="mergedColumnDefinitions"
    [components]="frameworkComponents"
    [getDataPath]="getDataPath"
    [getRowId]="getRowNodeId"
    [gridOptions]="gridOptions"
    [modules]="gridModules"
    [rowData]="rowData"
    (cellClicked)="onCellClicked($event)"
    class="nf-ag-grid-table ag-theme-alpine"
    id="ItemGrid"
    >
  </ag-grid-angular>
</div>
<div
  [ngClass]="{ open: openMenu }"
  [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }"
  class="tMenu action-menu"
  id="RowActionMenu"
  #contextMenu
  >
  @if (selectedItem.actionList.includes('update')) {
    <div
      (click)="openItem(selectedItem)"
      class="tActionRow"
      id="EditSelectionButton"
      >
      Edit
    </div>
  }
  @if (selectedItem.actionList.includes('go-to-update')) {
    <div
      (click)="goToEdit(selectedItem)"
      class="tActionRow"
      id="EditSelectionButton"
      >
      Go to Edit
    </div>
  }
  @if (selectedItem.actionList.includes('updateRoles') && editItem) {
    <div
      (click)="editItem(selectedItem)"
      class="tActionRow"
      id="RowEditRoles_{{ index }}"
      >
      Edit Roles
    </div>
  }
  @if (selectedItem.actionList.includes('editDetails') && editItemDetail) {
    <div
      (click)="editItemDetail(selectedItem)"
      class="tActionRow"
      id="RowEditRoles_{{ index }}"
      >
      Edit Details
    </div>
  }
  @if (selectedItem.actionList.includes('rotatePassword')) {
    <div
      (click)="resetItem(selectedItem)"
      class="tActionRow"
      id="RowReset_{{ index }}"
      >
      New Secret
    </div>
  }
  @if (
    selectedItem.actionList.includes('activateOrDeactivate') || selectedItem.actionList.includes('deactivate')
    ) {
    <div
      (click)="deactivateItem(selectedItem)"
      [hidden]="selectedItem.active === 0"
      class="tActionRow"
      id="RowDelete_{{ index }}"
      >
      Deactivate
    </div>
  }
  @if (selectedItem.actionList.includes('activateOrDeactivate') || selectedItem.actionList.includes('activate')) {
    <div
      (click)="activateItem(selectedItem.id)"
      [hidden]="selectedItem.active === 1"
      class="tActionRow"
      id="RowActivate_{{ index }}"
      >
      Activate
    </div>
  }
  @if (selectedItem.actionList.includes('reset') || selectedItem.actionList.includes('resetMfa')) {
    <div
      (click)="resetMFA(selectedItem)"
      class="tActionRow"
      id="RowResetMfa_{{ index }}"
      >
      Reset MFA
    </div>
  }
  @if (selectedItem.actionList.includes('resetPasskey')) {
    <div
      (click)="resetPasskey(selectedItem)"
      class="tActionRow"
      id="RowResetPasskey_{{ index }}"
      >
      Reset Passkey
    </div>
  }
  @if (selectedItem.actionList.includes('reinvite')) {
    <div
      (click)="reinviteUser(selectedItem)"
      class="tActionRow"
      id="RowReinvite_{{ index }}"
      >
      Re-invite User
    </div>
  }
  @if (selectedItem.actionList.includes('releaseIP')) {
    <div
      (click)="releaseIP(selectedItem)"
      class="tActionRow"
      id="RowReleaseIP_{{ index }}"
      >
      Release IP
    </div>
  }
  @if (selectedItem.actionList.includes('upgrade')) {
    <div
      (click)="upgrade(selectedItem)"
      class="tActionRow"
      id="UpgradeSelectionBtn"
      >
      Upgrade
    </div>
  }
  @if (selectedItem.actionList.includes('upgradeBootstrapper')) {
    <div
      (click)="upgradeBootstrapper(selectedItem)"
      class="tActionRow"
      id="UpgradeSelectionBtn"
      >
      Upgrade
    </div>
  }
  @if (selectedItem.actionList.includes('move')) {
    <div
      (click)="move(selectedItem)"
      class="tActionRow"
      id="UpgradeSelectionBtn"
      >
      Move
    </div>
  }
  @if (selectedItem.actionList.includes('reissue')) {
    <div
      (click)="reissueToken(selectedItem)"
      class="tActionRow"
      id="RowReissueToken_{{ index }}"
      >
      Reissue Token
    </div>
  }
  @if (selectedItem.actionList.includes('pingAgent')) {
    <div
      (click)="pingAgent(selectedItem)"
      class="tActionRow"
      id="ResetSelectionButton"
      >
      Check Connection
    </div>
  }
  @if (selectedItem.actionList.includes('re-enroll')) {
    <div
      (click)="reEnroll(selectedItem)"
      class="tActionRow"
      id="ResetSelectionButton"
      >
      Re-Enroll
    </div>
  }
  @if (selectedItem.actionList.includes('share')) {
    <div
      (click)="shareItem(selectedItem)"
      class="tActionRow"
      id="ShareSelectionButton"
      >
      Share
    </div>
  }
  @if (selectedItem.actionList.includes('delete')) {
    <div
      (click)="deleteItem(selectedItem)"
      class="tActionRow"
      id="DeleteSelectionButton"
      >
      Delete
    </div>
  }
  @if (selectedItem.actionList.includes('topology')) {
    <div
      (click)="openTopology(selectedItem)"
      class="tActionRow"
      id="TopologySelectionButton"
      >
      Visualize
    </div>
  }
  @if (selectedItem.actionList.includes('metrics')) {
    <div
      (click)="openMetrics(selectedItem)"
      class="tActionRow"
      id="MetricsSelectionButton"
      >
      Metrics
    </div>
  }
  @if (selectedItem.actionList.includes('events')) {
    <div
      (click)="openEvents(selectedItem)"
      class="tActionRow"
      id="EventsSelectionButton"
      >
      Events
    </div>
  }
  @if (selectedItem.actionList.includes('json')) {
    <div
      (click)="openJson(selectedItem)"
      class="tActionRow"
      id="JsonSelectionButton"
      >
      JSON
    </div>
  }
  @if (selectedItem.actionList.includes('onboard')) {
    <div
      (click)="onboard(selectedItem)"
      class="tActionRow"
      id="OnboardSelectionButton"
      >
      Onboard
    </div>
  }
  @if (selectedItem.actionList.includes('offboard')) {
    <div
      (click)="offboard(selectedItem)"
      class="tActionRow"
      id="OffboardSelectionButton"
      >
      Offboard
    </div>
  }
  @if (selectedItem.actionList.includes('enableFrontdoor')) {
    <div
      (click)="enableFrontdoor(selectedItem)"
      class="tActionRow"
      id="EnableFrontdoorSelectionButton"
      >
      Enable Frontdoor
    </div>
  }
  @if (selectedItem.actionList.includes('publicCert')) {
    <div
      (click)="openPublicCertModal(selectedItem)"
      class="tActionRow"
      id="PublicCertificateSelectionButton"
      >
      Public Certificate
    </div>
  }
  @if (selectedItem.actionList.includes('resume')) {
    <div
      (click)="resume(selectedItem)"
      class="tActionRow"
      id="ResumeSelectionButton"
      >
      Resume
    </div>
  }
  @if (selectedItem.actionList.includes('resize')) {
    <div
      (click)="resize(selectedItem)"
      class="tActionRow"
      id="ResizeSelectionButton"
      >
      Resize
    </div>
  }
  @if (selectedItem.actionList.includes('restartHost')) {
    <div
      (click)="restartHost(selectedItem)"
      class="tActionRow"
      id="RestartHostSelectionButton"
      >
      Restart Host
    </div>
  }
  @if (selectedItem.actionList.includes('restart')) {
    <div
      (click)="restart(selectedItem)"
      class="tActionRow"
      id="RestartSelectionButton"
      >
      Restart
    </div>
  }
  @if (selectedItem.actionList.includes('restoreBackup')) {
    <div
      (click)="restoreBackup(selectedItem)"
      class="tActionRow"
      id="RestartHostSelectionButton"
      >
      Restore Backup
    </div>
  }
  @if (selectedItem.actionList.includes('enableHA')) {
    <div
      (click)="enableHA(selectedItem)"
      class="tActionRow"
      id="EnableHASelectionButton"
      >
      Enable HA
    </div>
  }
  @if (selectedItem.actionList.includes('createBackup')) {
    <div
      (click)="createBackup(selectedItem)"
      class="tActionRow"
      id="RestartHostSelectionButton"
      >
      Create Backup
    </div>
  }
  @if (selectedItem.actionList.includes('restartProcess')) {
    <div
      (click)="restartProcess(selectedItem)"
      class="tActionRow"
      id="RestartProcessSelectionButton"
      >
      Restart Process
    </div>
  }
      @if (selectedItem.actionList.includes('downloadUsage')) {
    <div
      (click)="downloadUsage(selectedItem)"
      class="tActionRow"
      id="RestartProcessSelectionButton"
      >
      Download Usage
    </div>
  }
  @if (selectedItem.actionList.includes('suspend')) {
    <div
      (click)="suspend(selectedItem)"
      class="tActionRow"
      id="SuspendSelectionButton"
      >
      Suspend
    </div>
  }
</div>
<div
  [ngClass]="{ open: openHeaderMenu }"
  [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }"
  class="tMenu action-menu header-menu"
  id="HeaderActionMenu"
  >
  <div (click)="resetTableColumns()" class="tActionRow" id="ResetTableButton">Restore Default Table</div>
  @if (showRestartAll()) {
    <div (click)="restartAll($event)" class="tActionRow"> Restart All</div>
  }
  @if (showDownload()) {
    <div (click)="downloadAll($event)" class="tActionRow" id="DownloadAllToCSV">
      {{ view === 'users' ? 'Download User Roles' : 'Download All' }}
    </div>
  }
  @if (anySelected()) {
    <div (click)="downloadCsv($event)" class="tActionRow" id="DownloadCSV_Bulk">
      Download Selected
    </div>
  }
  @if (anySelected() && showBulkUpload()) {
    <div
      (click)="upgradeEdgeRouters($event)"
      class="tActionRow"
      id="Upgrade_Bulk"
      >
      Upgrade Selected
    </div>
  }
  @if (anySelected() && updateAuthPolicy && featureService.powerUserEnabled) {
    <div
      (click)="updateAuthPolicy($event)"
      class="tActionRow"
      id="updateAuthPolicy"
      >
      Update Auth Policy
    </div>
  }
  @if (showDownloadEvents()) {
    <div (click)="downloadAllEvents($event)" class="tActionRow" id="DownloadAllEvents">
      Download All
    </div>
  }
  @if (showDownloadEvents()) {
    <div
      (click)="downloadFilteredEvents($event)"
      class="tActionRow"
      id="DownloadCSV_Filtered"
      >
      Download Filtered
    </div>
  }
  @if (showUsageReport()) {
    <div
      (click)="downloadUsageReport($event)"
      class="tActionRow"
      id="DownloadUsageReport"
      >
      Download Usage Report
    </div>
  }
  @if (showDownloadCredentials()) {
    <div
      (click)="downloadCredentials($event)"
      class="tActionRow"
      id="DownloadCredentials_Bulk"
      >
      Download Credentials
    </div>
  }
</div>
<div
  (clickOutside)="closeHeaderFilter($event)"
  [ngClass]="{ open: showFilterOptions }"
  [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }"
  class="tMenu action-menu header-menu"
  id="HeaderFilterOptions"
  >
  @for (filter of filterOptions; track filter) {
    <div
      (click)="applyFilter($event, filter)"
      class="tActionRow"
      [ngClass]="{ 'has-icon': filter.icon }"
      [id]="filter.columnId"
      >
      @if (filter.bubbleClass) {
        <span [ngClass]="filter.bubbleClass" class="bubble">
          @if (filter.showLoader) {
            <svg class="circular" viewBox="25 25 50 50">
              <circle
                class="path"
                cx="50"
                cy="50"
                fill="none"
                r="20"
                stroke-miterlimit="10"
                stroke-width="3"
              ></circle>
            </svg>
          }
        </span>
      }
      @if (filter.icon) {
        <span class="os-icon {{ filter.icon }}"></span>
      }
      {{ filter.label }}
    </div>
  }
</div>
@if (showDateTimePicker) {
  <div
    class="date-time-container"
    [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }"
    (clickOutside)="closeHeaderFilter($event)"
    >
    <mat-form-field appearance="outline" class="data-table-date-range">
      <mat-label>Select Time Range</mat-label>
      <mat-date-range-input [rangePicker]="picker" (click)="picker.open()">
        <input
          matStartDate
          matInput
          readonly
          [(ngModel)]="startDate"
          (dateChange)="onDateRangeChanged()"
          />
          <input
            matEndDate
            matInput
            readonly
            [(ngModel)]="endDate"
            (dateChange)="onDateRangeChanged()"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker [calendarHeaderComponent]="rangeHeader"></mat-date-range-picker>
        </mat-form-field>
      </div>
    }
